import axios from './axios.config';
import { Inspection } from './inspection.service';

export interface Inventory {
    id: number;
    userId: number;
    trailerId: string;
    status: 'Entered' | 'Exited';
    entryTime: string;
    exitTime: string;
    url: string;
    createdAt: Date;
    updatedAt: Date;
};

export interface InventoryType {
    id: number;
    userId: number;
    trailerId: string;
    status: 'Entered' | 'Exited';
    entryTime: string;
    exitTime: string;
    url: string;
    inspection: Inspection | null;
    createdAt: Date;
    updatedAt: Date;
};

export const inventoryService = {
    get: async (): Promise<InventoryType[]> => {
        try {
            const response = await axios.get<{ data: InventoryType[] }>(`/inventory`);
            return response.data.data;
        } catch (error) {
            throw error;
        }
    },

    update: async (data: { id: number, trailerId: string }): Promise<Inventory> => {
        try {
            const response = await axios.put<Inventory>(`/inventory/update`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    manualSync: async (): Promise<Inventory> => {
        try {
            const response = await axios.put<Inventory>(`/inventory/manual-sync`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};